// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jo-1";
export var messageSideRight = "_jo-2";
export var orderLookupBubbleContainer = "_jo-0";
export var submitButton = "_jo-3";